import {Component, OnDestroy, OnInit} from '@angular/core';
import {DipRegistrationConfirmService} from '../core/services/dip-registration-confirm.service';
import {DipRegistrationContextService} from '../core/services/dip-registration-context.service';
import {TranslateService} from '@ngx-translate/core';
import {DipRegistrationService} from '../dip-registration.service';
import { DipRegistrationNavigationService } from '../core/services/dip-registration-navigation.service';
import { DiprsSpaLoggerService } from '../core/services/logger/diprs-spa-logger.service';
import { DipRegistrationLoggingNames } from '../core/enum/dip-registration-logging-names.enum';
import { LoggerEventEnum } from '../core/models/dip-registration-log-information.model';

@Component({
    selector: 'dip-registration-existing-account',
    templateUrl: './dip-registration-existing-account.component.html',
    styleUrls: ['./dip-registration-existing-account.component.scss'],
    standalone: false
})
export class DipRegistrationExistingAccountComponent implements OnInit, OnDestroy {
  resetPasswordUrl: string;
  version: string;
  sessionId: string;

  constructor(private dipRegistrationConfirmService: DipRegistrationConfirmService,
              private translateService: TranslateService,
              private dipRegistrationService: DipRegistrationService,
              private readonly dipRegistrationContextService: DipRegistrationContextService,
              private dipRegistrationNavigationService: DipRegistrationNavigationService,
              private spaLoggerService: DiprsSpaLoggerService) {
  }

  ngOnInit() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_ENTERED, DipRegistrationLoggingNames.EXISTING_ACCOUNT, { previousPageId: this.dipRegistrationNavigationService.getPreviousUrl() });
    this.sessionId = this.dipRegistrationContextService.getSessionId();
    this.version = this.dipRegistrationContextService.getVersionId();
    this.dipRegistrationContextService.resetContextFlag();
    this.dipRegistrationConfirmService.stop();
    this.resetPasswordUrl = `${this.translateService.instant('DIPRSRegistration.myInsurance.login.url')}${this.translateService.instant('DIPRSRegistration.myInsurance.resetPassword.fragment')}`;
  }

  async goToMyInsuranceLoginPage() {
    const url = this.translateService.instant('DIPRSRegistration.myInsurance.login.url');
    if (url) {
      this.spaLoggerService.info(LoggerEventEnum.FORWARD, DipRegistrationLoggingNames.EXISTING_ACCOUNT, { forwardUrl: url});
      await this.dipRegistrationService.killSession();
      window.location.href = url;
    }
  }

  ngOnDestroy() {
    this.spaLoggerService.info(LoggerEventEnum.PAGE_EXITED, DipRegistrationLoggingNames.EXISTING_ACCOUNT, null);
  }
}
